import { z } from "zod";

export const SystemViewUserItemSchema = z.object({
  Id: z.string(),
  IsAdmin: z.boolean().optional(),
  Roles: z.string().array().optional(),
  DisplayName: z.string().optional(),
  Login: z.string().optional(),
  FirstName: z.string().optional(),
  LastName: z.string().optional(),
  FullName: z.string().optional(),
  WorkPhone: z.string().optional(),
  Company: z.string().optional(),
  MobilePhone: z.string().optional(),
  Department: z.string().optional(),
  JobTitle: z.string().optional(),
  GenderCode: z.number().optional(),
  BirthDate: z.string().optional(),
  AccountId: z.string().optional(),
});

export type SystemViewUserItemType = z.infer<typeof SystemViewUserItemSchema>;
